import {
  OPEN_INTERACTIVITY_MODAL_DYNAMIC,
  OPEN_INTERACTIVITY_MODAL_STATIC,
  OPEN_RELATED,
  START_LOADING_MODAL,
  CLOSE_INTERACTIVITY_MODAL,
  SET_ERROR_MODAL,
  ERROR_MODAL
} from "../type";
import { getProductGiodicart } from "../../services/product.services";
import { formatter } from "../../helper/utility";
import { serverResponse } from "../../util/fakeServer";

export const openInteractivityModal = (props, id_code) => async (dispatch) => {
  try {
    dispatch({
      type: START_LOADING_MODAL
    });
    if (props.type === "plus") {
      const dataGiodi = await getProductGiodicart(
        id_code,
        serverResponse.config.id_listino
      );
      let formattedData = formatter(dataGiodi);

      const isEmptyObj = Object.keys(formattedData).length === 0;

      if (formattedData) {
        if (!isEmptyObj) {
          dispatch({
            type: OPEN_INTERACTIVITY_MODAL_DYNAMIC,
            payload: { props, formattedData }
          });
        } else {
          dispatch({
            type: ERROR_MODAL
          });
        }
      }
    } else {
      dispatch({
        type: OPEN_INTERACTIVITY_MODAL_STATIC,
        payload: props
      });
    }
  } catch (error) {
    dispatch({
      type: SET_ERROR_MODAL,
      payload: error
    });
  }
};

export const openRelated = (id_code) => async (dispatch) => {
  dispatch({
    type: START_LOADING_MODAL
  });

  try {
    const dataGiodi = await getProductGiodicart(
      id_code,
      serverResponse.config.id_listino
    );
    let formattedData = formatter(dataGiodi);

    dispatch({
      type: OPEN_RELATED,
      payload: formattedData
    });
  } catch (error) {
    dispatch({
      type: SET_ERROR_MODAL,
      payload: error
    });
  }
};

export const closeInteractivityModal = () => (dispatch) => {
  dispatch({
    type: CLOSE_INTERACTIVITY_MODAL
  });
};
